// src/theme.js
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  // ✅ ใช้สีของคุณเอง (mapping เข้ากับ MUI)
  palette: {
    primary: {
      main: "#00C2A9",
    },
    background: {
      default: "#0C111A",
      paper: "#1A2332",
      headerPanel: "#758e8bbd",
      bodyPanel: "#2c3133b3",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#F7C600",
      gray: "#737477",
      customGreen: "#34a293",
    },
    divider: "#2C384A",
  },

  // ✅ ใช้ฟอนต์ CPF Imm Sook ทั่วทั้งระบบ
  typography: {
    fontFamily: '"CPF Imm Sook", "Roboto", "Helvetica", "Arial", sans-serif',
  },

  // ✅ ถ้ายังอยากเก็บสีแบบ custom ไว้ใช้งานตรง ๆ
  customColors: {
    primary: "#00C2A9",
    background: "#0C111A",
    sidebar: "#1A2332",
    navbar: "#000",
    text: "#FFFFFF",
    accent: "#F7C600",
    border: "#2C384A",
  },
  colorStatus: {
    green: "#4caf50",
    lightGreen: "#50c8b1",
    yellow: "#ffeb3b",
    red: "#e53935",
    gray: "#a5a5a5",
    lightGray: "#737477",
    orange: "#e46c0b"
  },
  machineStatus: {
    green: "#0d381ec4",
    red: "#500a0ac9",
    yellow: "#4e4e0dc7",
    gray: "#3a3a3cd6",
  },
  machineBorderStatus: {
    green: "#137540",
    red: "#980d13",
    yellow: "#8d8955",
    gray: "#7f7f80",
  },
  skuBorderStatus: {
    green: "#282f2c",
    yellow: "#404136",
  },
});
